module.exports = __webpack_public_path__ + "media/images/mailer/left-rounded-border-red-8e16a2e18a34ebfac9de56f9a028fac2.png";